import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';
import { APIRoutes } from '../../global-misc/api-routes';

export interface InviteVerificationDetails {
  // Assuming the API returns at least these details upon successful verification
  inviteEmail: string;
  organisationName: string;
  // Add any other properties the API might return
}

// Interface for the response when accepting an invite (if any specific data is returned)
export interface AcceptInviteResponse {
  message: string;
  // organisationId?: string; // Potentially useful for navigation
}

@Injectable({ providedIn: 'root' })
export class AcceptInviteService {
  constructor(private http: HttpClient) {}

  async verifyInvite(token: string): Promise<InviteVerificationDetails> {
    const url = APIRoutes.INVITE_VERIFY_ROUTE.replace(':token', token);
    return firstValueFrom(this.http.get<InviteVerificationDetails>(url));
  }

  async acceptInvite(token: string): Promise<AcceptInviteResponse> {
    const url = APIRoutes.INVITE_ACCEPT_ROUTE.replace(':token', token);
    // Assuming accept is a POST request, adjust if it's GET or requires a body
    return firstValueFrom(this.http.post<AcceptInviteResponse>(url, {}));
  }
}
